export default __webpack_public_path__ + "static/media/struct8.cf03deb1.png";